import { setupYup } from "../../config/yup"
import { validateBr } from 'js-brasil';

const Yup = setupYup();

export const schema = Yup.object().shape({
  telefone: Yup.string().required().min(10),
  cpf: Yup.string().required()
    .test('cpf', 'CPF Inválido', function (value) {
      if (!value) return;
      return validateBr.cpf(value);
    }),
    departamento: Yup.string().required(),
    curriculo: Yup
      .mixed()
      .when('departamento', {
        is: (departamento) => departamento !== 'Cobranca - Operacao', 
        then: Yup.mixed().test(
          "curriculo",
          "Currículo obrigatório",
          file => !!file
        ),
        otherwise: Yup.mixed().notRequired()
      })
})